import * as DatasetHelper from '../dataset-helper';

/**
 * Apply a scaled quota to sub-category results. For example, selection of two (the "quota") matched
 * pairs of Fish Zones ("open"/"closed") within each BioRegion.
 */
export default function calculate(statistics, dataset, categoryFieldId, subCategoryFieldId,
                        calculationStepDefn) {

    // The primary category. eg: BioRegion.
    const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
    const categories = categoryField.categories;
    const numOfCategories = categories.length;

    // The secondary category. eg: Fish Zones ("open"/"closed").
    const subCategoryField = DatasetHelper.findField(dataset, subCategoryFieldId);

    // The property to bind the result to in the statistics object.
    const resultPropertyName = calculationStepDefn.result;

    // Determine the average size of a region. This assumes that the value assigned to
    // "accumulationOnAllSites" contains an accumulated size relevant to the primary category.
    // Where the primary category is BioRegion, this should likely be SUB_BIOKM2.
    const averageRegionSize = statistics.accumulationOnAllSites / numOfCategories;

    // Process each primary category.
    categories.forEach(category => {
      const categoryResult = statistics[category.value];

      // Determine the minimum value across the sub-categories. This identifies the minimum value
      // selected for each sub-category values. For example, with GBRMP Zones, this will identify the
      // number of paired reefs by determining which is the minimal value.
      const subCategoryResult = categoryResult[subCategoryField.fieldName];
      let minimum = undefined;
      Object.keys(subCategoryResult).forEach(key => {
        const value = subCategoryResult[key];
        if (!minimum || minimum > value) {
          minimum = value;
        }
      });
      if (!minimum) {
        minimum = 0;
      }

      // Scale the quota for the size of the region.
      const scaledQuota = calculationStepDefn.quota * categoryResult.accumulationOnAllSites /
        averageRegionSize;

      // Score = 1 if minimum meets quota, zero if minimum is zero, linear between, and capped at 1.
      let score = (minimum > 0 ? minimum / scaledQuota : 0);
      if (score > 1) {
        score = 1;
      }
      categoryResult[resultPropertyName] = (1 - score);
    });
  }



// WEBPACK FOOTER //
// ./src/app/utils/calculators/quota-calculator.js